<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <h4 class="earth-color">VEHICLE FEE REVENUE REPORT</h4>
      <div class="title-decoration"></div>
    </v-card-title>
    <v-layout row wrap>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <h6 class="earth-color">
            Vehicle Net Revenue (KSH {{ $roundOff(vehicleRevenueTotals.total_vehicle_net) }})
          </h6>
          <v-container>
            <ve-pie
              :data="vehicleRevenueData"
              :settings="chartSettingsRevenue"
              class="futuristic-chart"
            ></ve-pie>
          </v-container>
        </v-container>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12>
        <v-container>
          <h6 class="earth-color">
            Vehicle Net Discounts (KSH {{ $roundOff(vehicleRevenueTotals.total_vehicle_discount_net) }})
          </h6>
          <v-container>
            <ve-pie
              :data="vehicleRevenueDiscount"
              :settings="chartSettingsRevenue"
              class="futuristic-chart"
            ></ve-pie>
          </v-container>
        </v-container>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12>
        <v-container>
          <h5 class="earth-color">
            Vehicle Bed Nights ({{ vehicleRevenueTotals.total_bednights }})
          </h5>
          <v-container>
            <ve-histogram
              :data="vehicleRevenueBedNightsData"
              :settings="chartSettings"
              :loading="loading"
              class="futuristic-chart"
            ></ve-histogram>
          </v-container>
        </v-container>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="columns"
      :items="vehicleRevenueDataPrint"
      disable-sort
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear v-slot:progress color="#587e27" indeterminate></v-progress-linear>
      <template v-slot:items="{ item }">
        <td>{{ item.name }}</td>
        <td>KSH {{ $roundOff(item.total_gross_base) }}</td>
        <td>KSH {{ $roundOff(item.total_net_base) }}</td>
        <td>KSH {{ $roundOff(item.total_discount_gross) }}</td>
        <td>KSH {{ $roundOff(item.total_discount_net) }}</td>
        <td>{{ item.total_bed_nights }}</td>
        <td>{{ item.total_count }}</td>
      </template>
      <template v-slot:footer>
        <td :colspan="columns.length">
          <vue-json-to-csv
            :json-data="vehicleRevenueDataPrint"
            csv-title="Motor vehicle Fee"
            :labels="{
              name: { title: 'Vehicle Name' },
              total_gross_base: { title: 'GROSS TOTAL(KSH)' },
              total_net_base: { title: 'NET TOTAL(KSH)' },
              total_discount_gross: { title: 'GROSS DISCOUNT(KSH)' },
              total_discount_net: { title: 'NET DISCOUNT(KSH)' },
              total_bed_nights: { title: 'BED NIGHTS' },
              total_count: { title: 'COUNT' },
            }"
          >
            <v-btn
              depressed
              color="#587e27"
              class="futuristic-btn"
            >
              <b>Download CSV</b>
            </v-btn>
          </vue-json-to-csv>
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";
import VueJsonExcel from "vue-json-excel";

export default {
  components: { VueJsonExcel, VueJsonToCsv },
  name: "VehicleFeeRevenueReport",
  data() {
    return {
      chartSettings: {
        metrics: ["number"],
        dataOrder: {
          label: "number",
          order: "asc",
        },
      },
      chartSettingsRevenue: {
        metrics: ["amount"],
        dataOrder: {
          label: "amount",
          order: "asc",
        },
      },
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      loading: true,
      today: this.$moment.now(),
      revenue_date: {
        start_date: this.$moment(this.today).format("YYYY-MM-DD"),
        end_date: this.$moment(this.today).format("YYYY-MM-DD"),
        currency: this.$store.state.CurrencyStore.browser_currency_id,
      },
      reportFields: {
        Name: "name",
        Amount: "amount",
      },
      columns: [
        {
          text: "Vehicle",
          value: "name",
        },
        {
          text: "Gross Base",
          value: "total_gross_base",
        },
        {
          text: "Net Base",
          value: "total_net_base",
        },
        {
          text: "Discount Gross Base",
          value: "total_discount_gross",
        },
        {
          text: "Discount Net Base",
          value: "total_discount_net",
        },
        {
          text: "Bed Nights",
          value: "total_bed_nights",
        },
        {
          text: "Count",
          value: "total_count",
        },
      ],
    };
  },
  computed: {
    vehicleCountData: function () {
      var data = this.$store.state.ChartStore.vehicle_count;
      var columns = ["name", "number"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    vehicleRevenueData: function () {
      var data = this.$store.state.ChartStore.vehicle_revenue;
      var columns = ["name", "amount"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    vehicleRevenueDiscount: function () {
      var data = this.$store.state.ChartStore.vehicle_discounts;
      var columns = ["name", "amount"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    vehicleRevenueBedNightsData: function () {
      var data = this.$store.state.ChartStore.vehicle_bed_nights;
      var columns = ["name", "number"];
      var revenueData = [];
      revenueData.push(data);
      return {
        columns: columns,
        rows: data,
      };
    },
    vehicleRevenueDataPrint: function () {
      var data = this.$store.state.ChartStore.vehicle_tabular;
      return data;
    },
    vehicleRevenueTotals: function () {
      var data = this.$store.state.ChartStore.vehicle_totals;
      if (Object.keys(data).length === 0) {
        return {
          total_vehicle_net: 0,
          total_vehicle_discount_net: 0,
          total_bednights: 0,
        };
      } else {
        return data;
      }
    },
  },
  created() {
    this.$store.dispatch("get_vehicle_revenue_chart", this.revenue_date);
  },
  methods: {
    getData() {
      this.$store.dispatch("get_vehicle_revenue_chart", this.revenue_date);
    },
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.earth-color.h6 {
  font-size: 1.2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

.futuristic-chart {
  border-radius: 8px;
  padding: 8px;
  background: #f5f7fa;
}

.futuristic-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
}

.futuristic-table >>> th,
.futuristic-table >>> td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-table >>> th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
}

.futuristic-table >>> tr:hover {
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-card {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .earth-color.h6 {
    font-size: 1rem;
  }

  .futuristic-chart {
    padding: 6px;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 8px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .earth-color.h6 {
    font-size: 0.9rem;
  }

  .futuristic-chart {
    padding: 4px;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 6px;
    font-size: 0.85rem;
  }
}
</style>